export default {
    Looproutes: [9, 25, 26, 49],
    PaardrijRoutes: [17, 35, 36],
    MountainBikeRoutes: [7],
    OffroadBikeRoutes: [7, 47],
    KajakRoutes: [16, 32],
    SkeelerRoutes: [19],
    MultiMoveRoutes: [2, 8],
} 